import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=45d51674&"
import script from "./ChangePasswordView.vue?vue&type=script&lang=ts&"
export * from "./ChangePasswordView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports